import { KeyVal } from "../Layouts"
import { Modal, Form, Input, Button, notification, Tag, Avatar, List } from "antd"
import { useState } from "react"
import { useApp } from "../../model";
import { updatePassword } from "../../api/user";
import { logoutMe } from "../common/UserMenu";
import { UserOutlined, MailTwoTone, MobileTwoTone, HomeTwoTone } from "@ant-design/icons";
export default function UserProfile() {
    const { currentUser } = useApp()
    const [showPasswordResetForm, setShowPasswordResetForm] = useState(false);
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: 400,
            margin: '0 auto'
        }}>
            <List>

                <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                    <Avatar size='large' >{currentUser?.name?.slice?.(0, 1)}</Avatar>
                    <h1>{currentUser?.name}</h1>
                </div>
                <List.Item>
                    <KeyVal hideSplitor name={
                        <MobileTwoTone />
                    } value={currentUser?.phone} />
                </List.Item>
                <List.Item>
                    <KeyVal hideSplitor name={<MailTwoTone />} value={currentUser?.email} />
                </List.Item>
                <List.Item>
                    <KeyVal hideSplitor name={<HomeTwoTone />} value={<div style={{ display: 'inline-flex' }}>
                        {currentUser?.organizations.map((i, index) => <Tag key={index}>{i.name}</Tag>)}
                    </div>} />
                </List.Item>
                <List.Item>
                    <KeyVal hideSplitor name={<UserOutlined style={{ color: 'rgb(22, 119, 255)' }} />} value={<div style={{ display: 'inline-flex' }}>
                        {currentUser?.roles.map((i, index) => <Tag key={index}>{i.description}</Tag>)}
                    </div>} />
                </List.Item>

                <List.Item>
                    <Button type='primary' style={{width: '100%'}} onClick={() => {
                        setShowPasswordResetForm(true)
                    }}>修改密码</Button>
                </List.Item>

                <Modal title='修改密码' open={showPasswordResetForm} onCancel={() => {
                    setShowPasswordResetForm(false)
                }} destroyOnClose footer={null}>
                    <PasswordResetForm userId={currentUser?.userId} onDone={() => {
                        logoutMe()
                    }} onCancel={() => {
                        setShowPasswordResetForm(false)
                    }} />
                </Modal>
            </List>
        </div>
    )
}

const PasswordResetForm = (p: { onCancel: () => void, onDone: () => void, userId?: string }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false)
    return (
        <Form wrapperCol={{ span: 18 }} labelCol={{ span: 6 }} form={form}>
            <Form.Item label="旧密码" name={"oldPassword"} rules={[{ required: true }]}>
                <Input.Password placeholder="请输入当前密码" />
            </Form.Item>
            <Form.Item label="新密码" name={"newPassword"} rules={[{ required: true }]}>
                <Input.Password placeholder="请输入新密码" />
            </Form.Item>
            <Form.Item label="确认密码" name={"repeatPassword"} rules={[{ required: true }]}>
                <Input.Password placeholder="请再输入一遍新密码" />
            </Form.Item>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'space-around' }}>
                <Button onClick={p.onCancel}>取消</Button>
                <Button loading={submitting} type="primary" onClick={() => {
                    form.validateFields()
                        .then((values) => {
                            if (values.repeatPassword !== values.newPassword) {
                                notification.error({ message: '请确认两次输入的新密码一致' });
                                return
                            } else {
                                setSubmitting(true)
                                updatePassword({ ...values, userId: p.userId })
                                    .then(() => {
                                        setSubmitting(false)
                                        notification.success({
                                            message: '修改密码成功, 请重新登录',
                                            duration: 1000,
                                        });
                                        setTimeout(() => {
                                            p.onDone()
                                        }, 1000);
                                    })
                                    .catch((err: Error) => {
                                        notification.error({
                                            message: err.message || '修改失败,请重试'
                                        });
                                        setSubmitting(false)
                                    })
                            }
                        }).catch(() => { })
                }}>修改</Button>
            </div>
        </Form>
    )
}